import React__default, { createContext, useContext, useState } from 'react';
import Typography from '../Atoms/Typography.js';
import FloatingStack from '../Atoms/FloatingStack.js';
import { LazyMotion } from './../external_lib/framer-motion/dist/es/components/LazyMotion/index.js';
import { domAnimation } from './../external_lib/framer-motion/dist/es/render/dom/features-animation.js';
import { m } from './../external_lib/framer-motion/dist/es/render/dom/motion-minimal.js';

var ToastContext = createContext(null);
function ToastProvider(_a) {
    var children = _a.children;
    var _b = React__default.useState(false), _isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState(), props = _c[0], setProps = _c[1];
    var setData = function (toastProps) {
        setProps(toastProps);
    };
    var show = function () {
        setIsOpen(true);
        setTimeout(function () {
            setIsOpen(false);
        }, ((props === null || props === void 0 ? void 0 : props.timer) || 5) * 1000);
    };
    var onActionClicked = function () {
        var _a;
        (_a = props === null || props === void 0 ? void 0 : props.onActionClicked) === null || _a === void 0 ? void 0 : _a.call(props);
        setIsOpen(false);
    };
    var variants = {
        open: { opacity: 1, y: 0, scale: 1 },
        closed: { opacity: 0, y: 10, scale: 0.9 }
    };
    return (React__default.createElement(ToastContext.Provider, { value: { setData: setData, show: show } },
        children,
        React__default.createElement(LazyMotion, { features: domAnimation }, _isOpen && (React__default.createElement(FloatingStack, { order: 1, variant: props === null || props === void 0 ? void 0 : props.variant },
            React__default.createElement(m.div, { className: "toast", variants: variants, initial: "closed", animate: "open", exit: "closed" },
                React__default.createElement("div", { className: "toast-left" }, props === null || props === void 0 ? void 0 :
                    props.icon,
                    React__default.createElement(Typography, { variant: "bodyTextTwo", classes: "toast-title" }, props === null || props === void 0 ? void 0 : props.title)),
                (props === null || props === void 0 ? void 0 : props.action) && (React__default.createElement("div", { className: "toast-right", onClick: onActionClicked },
                    React__default.createElement(Typography, { variant: "buttonOne" }, props === null || props === void 0 ? void 0 : props.action)))))))));
}
function useToast() {
    var toast = useContext(ToastContext);
    return function (_a) {
        var _b = _a.timer, timer = _b === void 0 ? 15 : _b, title = _a.title, onActionClicked = _a.onActionClicked, action = _a.action, icon = _a.icon, variant = _a.variant;
        toast.setData({
            timer: timer,
            title: title,
            icon: icon,
            onActionClicked: onActionClicked,
            variant: variant,
            action: action
        });
        toast.show();
    };
}

export { ToastProvider, useToast as default };
//# sourceMappingURL=Toast.js.map
